import { Children } from "react";
import { billingRoutes } from "./billing/routes";
import { settingUserRoutes } from "./user/routes";

import { Outlet } from "react-router-dom";

// import BillingDetail from "./pages/BillingDetail";
import { AppRoute } from "src/types/routes";

export const settingsRoutes:AppRoute[] = [
    { 
        path: "/settings/*", 
        element: <Outlet />,
        children: [
            ...billingRoutes,
            ...settingUserRoutes
        ] 

    },
    
    // { path: "billing/:id", element: <BillingDetail /> }
];

